"use strict";
// AUTO-GENERATED from contracts/markets/programs/markets/src/error/*.rs
// via scripts/generate-error-package.ts.
// Do NOT edit by hand — run `pnpm --filter @morfi/errors run generate` after a contract error change.
Object.defineProperty(exports, "__esModule", { value: true });
exports.OPINION_ERROR_BY_CODE = exports.OPINION_ERRORS = void 0;
exports.parseOpinionError = parseOpinionError;
exports.isOpinionError = isOpinionError;
exports.OPINION_ERRORS = {
    InvalidOutcomeCount: {
        code: 6000,
        name: 'InvalidOutcomeCount',
        msg: 'outcome count must be between 2 and 10',
        module: 'markets',
    },
    EmptyManifestCommitment: {
        code: 6001,
        name: 'EmptyManifestCommitment',
        msg: 'Pinata manifest commitment cannot be all zeroes',
        module: 'markets',
    },
    InvalidInitialVirtualQuote: {
        code: 6002,
        name: 'InvalidInitialVirtualQuote',
        msg: 'initial virtual quote must be greater than zero',
        module: 'markets',
    },
    InvalidInitialTokenSupply: {
        code: 6003,
        name: 'InvalidInitialTokenSupply',
        msg: 'initial token supply must be greater than zero',
        module: 'markets',
    },
    InvalidInitialBacking: {
        code: 6004,
        name: 'InvalidInitialBacking',
        msg: 'initial backing must meet the configured minimum',
        module: 'markets',
    },
    InvalidConfig: {
        code: 6005,
        name: 'InvalidConfig',
        msg: 'market configuration is invalid',
        module: 'markets',
    },
    InvalidFeeSplit: {
        code: 6006,
        name: 'InvalidFeeSplit',
        msg: 'backer fee split configuration is invalid',
        module: 'markets',
    },
    InvalidPda: {
        code: 6007,
        name: 'InvalidPda',
        msg: 'account does not match its canonical PDA',
        module: 'markets',
    },
    AccountAlias: {
        code: 6008,
        name: 'AccountAlias',
        msg: 'economically distinct accounts cannot alias',
        module: 'markets',
    },
    InvalidPrefundedAccount: {
        code: 6009,
        name: 'InvalidPrefundedAccount',
        msg: 'prefunded PDA must remain system-owned, empty, and non-executable',
        module: 'markets',
    },
    CreationPrefundLimitExceeded: {
        code: 6010,
        name: 'CreationPrefundLimitExceeded',
        msg: 'too many creation PDAs require prefunding recovery; rotate the market nonce',
        module: 'markets',
    },
    AccountAlreadyInitialized: {
        code: 6011,
        name: 'AccountAlreadyInitialized',
        msg: 'deterministic account is already initialized',
        module: 'markets',
    },
    InvalidMintAccount: {
        code: 6012,
        name: 'InvalidMintAccount',
        msg: 'classic SPL mint is invalid',
        module: 'markets',
    },
    InvalidTokenAccount: {
        code: 6013,
        name: 'InvalidTokenAccount',
        msg: 'classic SPL token account is invalid',
        module: 'markets',
    },
    ArithmeticOverflow: {
        code: 6014,
        name: 'ArithmeticOverflow',
        msg: 'checked arithmetic failed',
        module: 'markets',
    },
    InvalidMarketInitialization: {
        code: 6015,
        name: 'InvalidMarketInitialization',
        msg: 'new market failed its initialization invariants',
        module: 'markets',
    },
    MarketNotTrading: {
        code: 6016,
        name: 'MarketNotTrading',
        msg: 'market is not open for trading',
        module: 'markets',
    },
    OutcomeNotActive: {
        code: 6017,
        name: 'OutcomeNotActive',
        msg: 'outcome is not active for this market',
        module: 'markets',
    },
    InvalidOutcomeMintState: {
        code: 6018,
        name: 'InvalidOutcomeMintState',
        msg: 'outcome mint state is malformed or inconsistent with market state',
        module: 'markets',
    },
    ZeroProgress: {
        code: 6019,
        name: 'ZeroProgress',
        msg: 'trade amount must make positive progress',
        module: 'markets',
    },
    AmountBelowMinimum: {
        code: 6020,
        name: 'AmountBelowMinimum',
        msg: 'trade amount is below the configured minimum',
        module: 'markets',
    },
    SlippageExceeded: {
        code: 6021,
        name: 'SlippageExceeded',
        msg: "trade output is below the caller's slippage limit",
        module: 'markets',
    },
    InsufficientTradeBalance: {
        code: 6022,
        name: 'InsufficientTradeBalance',
        msg: 'trader does not hold enough outcome tokens',
        module: 'markets',
    },
    UnexpectedVaultDelta: {
        code: 6023,
        name: 'UnexpectedVaultDelta',
        msg: 'a token balance changed by an unexpected amount',
        module: 'markets',
    },
    UnderCollateralizedCurveVault: {
        code: 6024,
        name: 'UnderCollateralizedCurveVault',
        msg: 'market quote custody is below recorded curve, prize, backer, and migration liabilities',
        module: 'markets',
    },
    InvalidMarketState: {
        code: 6025,
        name: 'InvalidMarketState',
        msg: 'stored market state is internally inconsistent',
        module: 'markets',
    },
    InvalidClock: {
        code: 6026,
        name: 'InvalidClock',
        msg: 'clock value cannot be represented by the market accounting model',
        module: 'markets',
    },
    ResolutionTooEarly: {
        code: 6027,
        name: 'ResolutionTooEarly',
        msg: 'market cannot resolve before its configured minimum delay',
        module: 'markets',
    },
    ResolutionThresholdNotReached: {
        code: 6028,
        name: 'ResolutionThresholdNotReached',
        msg: 'no outcome has reached the configured conviction threshold',
        module: 'markets',
    },
    CandidateWinnerMismatch: {
        code: 6029,
        name: 'CandidateWinnerMismatch',
        msg: 'candidate winner does not match the deterministic conviction winner',
        module: 'markets',
    },
    ResolutionThresholdReached: {
        code: 6030,
        name: 'ResolutionThresholdReached',
        msg: 'an outcome reached the conviction threshold; resolve before trading again',
        module: 'markets',
    },
    ResolutionCandidateNotMature: {
        code: 6031,
        name: 'ResolutionCandidateNotMature',
        msg: 'resolution candidate has not completed its sustained eligibility window',
        module: 'markets',
    },
    ResolutionCandidateNotLocked: {
        code: 6032,
        name: 'ResolutionCandidateNotLocked',
        msg: 'resolution candidate is not locked for deterministic resolution',
        module: 'markets',
    },
    MarketNotResolved: {
        code: 6033,
        name: 'MarketNotResolved',
        msg: 'market has not completed economic resolution',
        module: 'markets',
    },
    InvalidWinningMint: {
        code: 6034,
        name: 'InvalidWinningMint',
        msg: 'the supplied account is not the canonical winning outcome mint',
        module: 'markets',
    },
    ClaimExceedsSupply: {
        code: 6035,
        name: 'ClaimExceedsSupply',
        msg: 'the requested claim exceeds the live mint supply',
        module: 'markets',
    },
    NoClaimableLiability: {
        code: 6036,
        name: 'NoClaimableLiability',
        msg: 'the recorded claim liability is empty',
        module: 'markets',
    },
    UnauthorizedPlatformTreasury: {
        code: 6037,
        name: 'UnauthorizedPlatformTreasury',
        msg: 'only the immutable platform treasury may withdraw platform fees',
        module: 'markets',
    },
    InsufficientPlatformFees: {
        code: 6038,
        name: 'InsufficientPlatformFees',
        msg: 'the platform fee vault cannot cover the requested withdrawal',
        module: 'markets',
    },
    MigrationNotPending: {
        code: 6039,
        name: 'MigrationNotPending',
        msg: 'market is not ready for winner liquidity migration',
        module: 'markets',
    },
    InvalidMigrationAmounts: {
        code: 6040,
        name: 'InvalidMigrationAmounts',
        msg: 'recorded winner migration amounts are inconsistent',
        module: 'markets',
    },
    InvalidMigrationAmm: {
        code: 6041,
        name: 'InvalidMigrationAmm',
        msg: 'Morfi CP-Swap program or protected configuration is invalid',
        module: 'markets',
    },
    InvalidMigrationAmmAccount: {
        code: 6042,
        name: 'InvalidMigrationAmmAccount',
        msg: 'a protected CP-Swap account is not canonical',
        module: 'markets',
    },
    InvalidMigrationVault: {
        code: 6045,
        name: 'InvalidMigrationVault',
        msg: 'the temporary winner migration source is malformed',
        module: 'markets',
    },
    MigrationCpiFailed: {
        code: 6046,
        name: 'MigrationCpiFailed',
        msg: 'protected CP-Swap initialization failed',
        module: 'markets',
    },
    NoSweepableLiability: {
        code: 6047,
        name: 'NoSweepableLiability',
        msg: 'the recorded liability is empty or was already swept',
        module: 'markets',
    },
    LiabilitySweepTooEarly: {
        code: 6048,
        name: 'LiabilitySweepTooEarly',
        msg: 'the configured liability sweep deadline has not elapsed',
        module: 'markets',
    },
    LifecycleCleanupNotReady: {
        code: 6049,
        name: 'LifecycleCleanupNotReady',
        msg: 'lifecycle cleanup requires completed economic resolution',
        module: 'markets',
    },
    WinnerMigrationPending: {
        code: 6050,
        name: 'WinnerMigrationPending',
        msg: 'winner outcome authority must remain until migration is terminal',
        module: 'markets',
    },
    InvalidMintAuthorityState: {
        code: 6051,
        name: 'InvalidMintAuthorityState',
        msg: 'mint authority state does not match the lifecycle ledger',
        module: 'markets',
    },
    InvalidWinnerMetadataText: {
        code: 6052,
        name: 'InvalidWinnerMetadataText',
        msg: 'winner metadata fields are malformed',
        module: 'markets',
    },
    InvalidWinnerMetadataProof: {
        code: 6053,
        name: 'InvalidWinnerMetadataProof',
        msg: 'winner metadata proof does not match the market manifest commitment',
        module: 'markets',
    },
    InvalidWinnerMetadata: {
        code: 6054,
        name: 'InvalidWinnerMetadata',
        msg: 'winner metadata account is not canonical and immutable',
        module: 'markets',
    },
    WinnerMetadataCpiFailed: {
        code: 6055,
        name: 'WinnerMetadataCpiFailed',
        msg: 'Metaplex winner metadata creation failed',
        module: 'markets',
    },
    UnauthorizedConfiguration: {
        code: 6056,
        name: 'UnauthorizedConfiguration',
        msg: 'configuration signer is not the current program upgrade authority',
        module: 'markets',
    },
    InvalidConfigurationParameters: {
        code: 6057,
        name: 'InvalidConfigurationParameters',
        msg: 'configuration parameters violate Markets bounds',
        module: 'markets',
    },
    InvalidProtectedAmmConfig: {
        code: 6058,
        name: 'InvalidProtectedAmmConfig',
        msg: 'protected Morfi CP-Swap configuration is invalid',
        module: 'markets',
    },
    ConfigurationAccountAlias: {
        code: 6059,
        name: 'ConfigurationAccountAlias',
        msg: 'economically distinct configuration accounts cannot alias',
        module: 'markets',
    },
    ConfigurationArithmeticOverflow: {
        code: 6060,
        name: 'ConfigurationArithmeticOverflow',
        msg: 'checked configuration arithmetic failed',
        module: 'markets',
    },
    UnauthorizedTimedMarketAdmin: {
        code: 6062,
        name: 'UnauthorizedTimedMarketAdmin',
        msg: 'only the current config admin may authorize timed markets',
        module: 'markets',
    },
    InvalidTimedMarketSchedule: {
        code: 6063,
        name: 'InvalidTimedMarketSchedule',
        msg: 'timed market schedule is invalid',
        module: 'markets',
    },
    TimedMarketScheduleConflict: {
        code: 6064,
        name: 'TimedMarketScheduleConflict',
        msg: 'timed market schedule changed since the caller observed it',
        module: 'markets',
    },
    TimedMarketScheduleClosed: {
        code: 6065,
        name: 'TimedMarketScheduleClosed',
        msg: 'timed market schedule cannot change at or after its deadline',
        module: 'markets',
    },
    TimedMarketStartImmutable: {
        code: 6066,
        name: 'TimedMarketStartImmutable',
        msg: 'timed market start is immutable once trading opens',
        module: 'markets',
    },
    TimedMarketEndMustExtend: {
        code: 6067,
        name: 'TimedMarketEndMustExtend',
        msg: 'an open timed market deadline may only be strictly extended',
        module: 'markets',
    },
    BackingClosed: {
        code: 6068,
        name: 'BackingClosed',
        msg: 'backing is locked or this timed market no longer accepts funding',
        module: 'markets',
    },
    InvalidBackingAmount: {
        code: 6069,
        name: 'InvalidBackingAmount',
        msg: 'backing amount is zero, below the configured minimum, or exceeds available shares',
        module: 'markets',
    },
    MarketConfigDisabled: {
        code: 6070,
        name: 'MarketConfigDisabled',
        msg: 'market config is disabled for new market creation',
        module: 'markets',
    },
    InvalidGiftAmount: {
        code: 6071,
        name: 'InvalidGiftAmount',
        msg: 'gift amount must be greater than zero',
        module: 'markets',
    },
    InvalidHandlerHash: {
        code: 6072,
        name: 'InvalidHandlerHash',
        msg: 'handler hash must not be all zeros',
        module: 'markets',
    },
    GiftAlreadyClaimed: {
        code: 6073,
        name: 'GiftAlreadyClaimed',
        msg: 'gift has already been claimed',
        module: 'markets',
    },
    MarketCreationRestricted: {
        code: 6074,
        name: 'MarketCreationRestricted',
        msg: 'market creation requires the current config admin',
        module: 'markets',
    },
    UnauthorizedConfigAdmin: {
        code: 6075,
        name: 'UnauthorizedConfigAdmin',
        msg: 'only the current config admin may perform this operation',
        module: 'markets',
    },
    UnauthorizedMarketCreator: {
        code: 6076,
        name: 'UnauthorizedMarketCreator',
        msg: 'only the market creator may authorize outcome preparation',
        module: 'markets',
    },
    InvalidFirstTouchClaim: {
        code: 6077,
        name: 'InvalidFirstTouchClaim',
        msg: "the supplied first-touch claim does not match the market's verified history",
        module: 'markets',
    },
};
exports.OPINION_ERROR_BY_CODE = new Map(Object.values(exports.OPINION_ERRORS).map((e) => [e.code, e]));
function parseOpinionError(code) {
    return exports.OPINION_ERROR_BY_CODE.get(code);
}
function isOpinionError(code) {
    return exports.OPINION_ERROR_BY_CODE.has(code);
}
